import React, { useState } from 'react'
import { MDBInput } from 'mdbreact';
import axios from 'axios'
import useTraeDatos from '../hooks/useTraeDatos';
import { traeIdNombre, existeRegistro, recibeImagen, errores } from '../hooks/Funciones'
import fotoVacia from '../../paginas/img/fotoVacia.jpg'
import moment from 'moment'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { es } from 'date-fns/esm/locale';

const SubirEditCupon = ({ baseUrl, data, setData, setFuncion, registroSelect, TituloBtn, funcion }) => {
	const [registro, setRegistro] = useState(funcion === 'editar' ? registroSelect : { activo: true, })
	//registro.fechatermino = moment(registroSelect.fechatermino).toDate();
	const [error, setError] = useState({ activo: false })
	const creaFormData = (registro, METHOD) => {

		let { id, nombre, codigo, descuento, activo, fechatermino, porcentaje} = registro
		let f = new FormData()
		if (METHOD === 'PUT') { f.append('id', id) }
		f.append('nombre', nombre)
		f.append('codigo', codigo)
		f.append('descuento', descuento)
		f.append('METHOD', METHOD)
		f.append('activo', activo)
		f.append('porcentaje', porcentaje)
		f.append('fechatermino', moment(fechatermino).format('YYYY-MM-DD HH:mm:ss'))
		return f
	}

	//Consulta para subir o crear los datos 
	const peticionPost = async () => {
		let { nombre, codigo, descuento, activo, fechatermino , porcentaje} = registro

		if (!existeRegistro(data, nombre)) {
			if (nombre !== undefined && codigo !== undefined && descuento !== undefined && fechatermino !== undefined && porcentaje !== undefined) {
				let f = creaFormData(registro, 'POST')
				await axios.post(baseUrl, f)
					.then(response => {
						console.log('result', response.data)
						let resultFormat = { ...response.data }
						setData([resultFormat, ...data])
						setRegistro({ activo: false })
						errores('Limpio', setError)
						setFuncion('ver')

					}).catch(error => {
						console.log(error);
					})
			} else errores('CampoVacio', setError)
		} else errores('Existe', setError)

	}

	const ProcedimientoPut = async () => {

		let { id, nombre, codigo, descuento, activo, fechatermino, porcentaje } = registro

		let f = creaFormData(registro, 'PUT')
		await axios.post(baseUrl, f)

			.then(response => {

				console.log(response.data)
				let dataNueva = data
				dataNueva.map(item => {
					if (item.id === id) {
						item.nombre = nombre
						item.codigo = codigo
						item.descuento = descuento
						item.activo = activo
						item.fechatermino = fechatermino 
						item.porcentaje = porcentaje 
					}
				})
				setData(dataNueva)
				errores('Limpio', setError)
			}).catch(error => {
				console.log('muestra erro: ' + error);
			})
		setFuncion('ver')
	}

	const peticionPut = () => {

		let { nombre, activo, descripcion } = registro

		if (nombre !== '' && descripcion !== '') {
			ProcedimientoPut()
		} else errores('CampoVacio', setError)

	}

	return (
		<div>
			<div className="row">
				<div className="col-md-12">
					{error.activo ? <span className="error"> Error: {error.mensaje}</span> : null}
					<div><hr />

						<div className='row'>
							<div className='col-md-9'>
								<div className='custom-control custom-switch '>
									<input type='checkbox' name="activo" className='custom-control-input form-control-lg mb-4' id='customSwitches'
										checked={registro.activo}
										onChange={e => setRegistro({ ...registro, activo: !registro.activo })}
										readOnly
									/>
									<label className='custom-control-label' htmlFor='customSwitches'>Activar/Desactivar</label>
								</div>
								<MDBInput
									label="Nombre del cupon" name="nombre" required className={error.nombre ? "form-control is-invalid" : null} outline
									value={registro.nombre}
									onChange={e => setRegistro({ ...registro, nombre: e.target.value })}
								/>
								<div className="row">
									<div className='col-md-12'>
										<MDBInput
											label="Codigo"
											name="codigo"
											required
											className={error.campoClave ? "form-control is-invalid" : null}
											outline
											value={registro.codigo}
											onChange={e => setRegistro({ ...registro, codigo: e.target.value })}
										/>
									</div>
								</div>
								<div className="row">
									<div className='col-md-12'>
										<MDBInput
											label="Descuento/valor"
											name="descuento"
											required
											type='number'
											className={error.campoClave ? "form-control is-invalid" : null}
											outline
											value={registro.descuento}
											onChange={e => setRegistro({ ...registro, descuento: e.target.value })}
										/>
									</div>
								</div>
								<div className="row">
									<div className='col-md-12'>
										<label htmlFor='tipo'>Tipo:</label>
										<div className="input-group">
											<select className="form-control" id='porcentaje' name='porcentaje' value={registro.porcentaje} onChange={e => setRegistro({ ...registro, porcentaje: e.target.value })}>
												<option value='true'>Porcentaje</option>
												<option value='false'>Valor fijo</option>
											</select>
										</div>
									</div>
								</div>
								<div className="row pt-4">
									<div className='col-md-12'>
										<label htmlFor='fecha'>Fecha termino oferta:</label>
										<DatePicker
											selected={registro.fechatermino}
											onChange={date => {
												setRegistro({ ...registro, fechatermino: date });
											}}
											dateFormat="dd/MM/yyyy HH:mm:ss"
											showTimeSelect
											timeFormat="HH:mm:ss"
											className="form-control"
											locale={es}
										/>
									</div>
								</div>
							</div>
						</div>

						<br />
						<div className="col text-center">
							<button onClick={funcion === 'editar' ? peticionPut : peticionPost} className="btn boton_estandar">{TituloBtn} </button>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default SubirEditCupon